import { useMemo } from 'react';
import type { FC } from 'react';
import { useTranslatableContentState } from '@application/state';
import { useTranslateString } from '@application/api';
import type { TranslatableContentProps } from './types';
import * as Styled from './styled';

export const TranslatableContent: FC<TranslatableContentProps> = (props) => {
  const { content, format = 'text', DisplayComponent } = props;
  const { targetLanguage } = useTranslatableContentState();

  const { translation, loading } = useTranslateString({ content, format });

  const formattedContent = useMemo(() => {
    if (!targetLanguage) {
      return content;
    }
    return translation;
  }, [content, targetLanguage, translation]);

  if (loading) {
    return <Styled.Loading />;
  }
  return DisplayComponent ? (
    <DisplayComponent
      dangerouslySetInnerHTML={{
        __html: formattedContent,
      }}
    />
  ) : (
    formattedContent
  );
};
